<template>
	<span class="glyphicon" v-bind:class="{ 'text-success glyphicon-ok' : status, 'text-danger glyphicon-remove' : !status }" aria-hidden="true" v-on:click="toggleStatus"></span>
</template>

<script>

export default {
    props: ['accepted', 'meet_entry_event_id'],
    data: function () {
        return {
            // meet_entry_event_id: this.meet_entry_event_id,
            status: this.accepted == 1 ? true : false
        }
    },
    methods: {
    	updateAcceptedOnServer() {
            console.log('Updating acceptance status');

            axios.put(`/api/meet_entry/set_event_acceptance/${this.meet_entry_event_id}?accepted=${this.status}`).then((response) => {
                // this.times = response.data;
                console.log(response.data);
                this.status = response.data.accepted;
            });
    	},
    	toggleStatus() {
    		console.log('Toggling status');
    		this.status =  ! this.status;
    		this.updateAcceptedOnServer();
    	},
    },
    mounted() {

    }
}
</script>